const INITIAL_STATE = {
  segmentos: {
    data: [],
    current_page: 1,
    last_page: 1,
    total: 0
  },
  selectOptions: [],
  selectOptionsDefault: [],
  segmento: null
}

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case 'SEGMENTOS_FETCHED':
      return { ...state, segmentos: action.payload }
    case 'SEGMENTO_FETCHED':
      return { ...state, segmento: action.payload }
    case 'SEGMENTOS_FETCHED_SELECT_OPTIONS':
      return { ...state, selectOptions: action.payload }
    case 'SEGMENTOS_FETCHED_SELECT_DEFAULT_OPTIONS':
      return { ...state, selectOptionsDefault: action.payload }
    default:
      return state
  }
}